import { message } from 'antd'
import { evoClient, putPart } from '$api/client'
import { useEffect } from 'react'

export { useProgressColor } from './useProgressColor'

export function startTimer(interval, callback) {
  return setInterval(callback, interval)
}

export function stopTimer(timerId) {
  if (timerId) {
    clearInterval(timerId)
  }
}

export function updateStatusAttributes(
  partToUpdate,
  typeOfAttribute,
  attributeKey,
  attributeValue,
) {
  const value = attributeValue.toString()
  const existingService = partToUpdate[typeOfAttribute].find(
    (x) => x.key === attributeKey,
  )
  if (existingService) {
    //update attribute
    const objectToUpdate = partToUpdate[typeOfAttribute].find(
      (obj) => obj.key === attributeKey,
    )
    if (objectToUpdate) {
      objectToUpdate.value = value
    }
  } else {
    partToUpdate[typeOfAttribute].push({
      key: attributeKey,
      value: value,
      description: 'string',
    })
  }
  return partToUpdate
}

export const fallback =
  'data:image/png;base64,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'

export const convertStepToStatusInfo = (step) => {
  switch (step) {
    case 0:
      return 'active'
    case 1:
      return 'in_progress'
    case 2:
      return 'in_delivery'
    case 3:
      return 'finished'
    default:
      return 'unknown'
  }
}

export const convertToPercentage = (statusinfo) => {
  if (statusinfo === 'active') {
    return 0
  } else if (statusinfo === 'finished') {
    return 100
  } else {
    switch (statusinfo) {
      case 'in_progress':
        return 33
      case 'in_delivery':
        return 66
      default:
        return 3
    }
  }
}

export const convertStatusInfoToStep = (step) => {
  switch (step) {
    case 'active':
      return 0
    case 'in_progress':
      return 1
    case 'in_delivery':
      return 2
    case 'finished':
      return 3
    case 'rejected':
      return 1
    default:
      return 0
  }
}

export const checkFileSize = (size, limit = '5 MB', t) => {
  const num = parseFloat(limit)
  let factor = 1024 * 1024
  if (limit.match(/G/i)) {
    factor = 1024 * 1024 * 1024
  } else if (limit.match(/k/i)) {
    factor = 1024
  }

  const isSmaller = size < num * factor
  if (!isSmaller && typeof t === 'function') {
    message.error(t('parts_master_data.file_too_large', { limit }))
  }
  return isSmaller
}

export const resetFcOnAttributeChange = async (record) => {
  if (record) {
    let editedPart = record
    let filteredAttributes = editedPart.attributes.filter(
      (item) =>
        item.key !== 'Feasibility Check' &&
        item.key !== 'Technical Suitability',
    )
    editedPart.attributes = filteredAttributes
    return evoClient.put(`${putPart}${record.id}`, editedPart, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }
}

export const hexToRGBA = (hex, opacity) => {
  hex = hex.replace(/^#/, '')

  var r = parseInt(hex.substring(0, 2), 16)
  var g = parseInt(hex.substring(2, 4), 16)
  var b = parseInt(hex.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const useIgnoreCMP = () => {
  const MAX_TRIES = 10

  useEffect(() => {
    const closeCMP = () => {
      if (window.UC_UI && window.UC_UI.closeCMP) {
        window.UC_UI.closeCMP()
      }
    }

    const openCMP = () => {
      const userInteraction = localStorage.getItem('uc_user_interaction')
      if (
        userInteraction === 'false' &&
        window.UC_UI &&
        window.UC_UI.showFirstLayer
      ) {
        window.UC_UI.showFirstLayer()
      }
    }

    let tries = 0
    const interval = setInterval(() => {
      tries += 1
      if (window.UC_UI || tries >= MAX_TRIES) {
        if (window.UC_UI) {
          closeCMP()
        }
        clearInterval(interval)
      }
    }, 100)

    return () => {
      clearInterval(interval)
      openCMP()
    }
  }, [])
}
